import React from 'react';

interface UtteranceCollectionIconProps {
  style?: React.CSSProperties;
}

const UtteranceCollectionIcon: React.FC<UtteranceCollectionIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Utterance Collection</title>
      <g clipPath="url(#clip0)">
        <path d="M19.485 3.75L12.99 0 0 7.5V15l11.688-4.686 7.797-6.564z" fill="#6A11EA" />
        <path d="M6.495 26.25L12.99 30l12.99-7.5V15l-9.654 3.522-9.831 7.728z" fill="#FD9D52" />
        <path d="M19.485 3.75L0 15v7.5l6.495 3.75L25.98 15V7.5l-6.495-3.75z" fill="#943CFF" />
        <path
          d="M11.187 10.821h5.982l.873 3.645-.915 5.646L25.98 15V7.5l-6.495-3.75-12.246 7.071h3.948z"
          fill="#DD45D3"
        />
        <path
          d="M7.239 10.821v4.965h2.484a2.485 2.485 0 01-2.484 2.484v2.484a4.965 4.965 0 004.965-4.965v-4.968H7.239zM14.685 10.821v4.965h2.484a2.485 2.485 0 01-2.484 2.484v2.484a4.965 4.965 0 004.965-4.965v-4.968h-4.965z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UtteranceCollectionIcon;
